import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatCommonModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { PepperiModule } from '@pepperi/ngx-lib';
import {
    PepperiIconModule,
    PepperiIconRegistry,
    pepperiIconSystemMenu,
    pepperiIconSystemBolt,
    pepperiIconIndicatorDotPlaceholder
} from '@pepperi/ngx-lib/icon';
import { PepperiFieldTitleModule } from '@pepperi/ngx-lib/field-title';
import { PepperiFilesUploaderModule } from '@pepperi/ngx-lib/files-uploader';

import { PepperiImageComponent } from './image.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        // Material modules,
        MatCommonModule,
        MatFormFieldModule,
        MatIconModule,
        // Pepperi modules
        PepperiModule,
        PepperiIconModule,
        PepperiFieldTitleModule,
        PepperiFilesUploaderModule,
    ],
    exports: [ PepperiImageComponent ],
    declarations: [ PepperiImageComponent ],
})
export class PepperiImageModule {
    constructor(private pepperiIconRegistry: PepperiIconRegistry) {
        this.pepperiIconRegistry.registerIcons([
            pepperiIconSystemMenu,
            pepperiIconSystemBolt,
            pepperiIconIndicatorDotPlaceholder
        ]);
    }
}
